
/* ===== 검사 목록 모달 (KRDS) — 홈 카드와 동일한 디자인 언어 ===== */
(function(){
  var _lastFocus=null;

  function itemHTML(c, isDone){
    var dn=false; try{ dn=isDone?isDone(c):false; }catch(e){}
    var _pli=(window.aipiaCurrentLang==='en');
    var meta=[];
    if(c.dur) meta.push(c.dur);
    if(c.items) meta.push(typeof c.items==='number' ? (_pli?(c.items+' items'):(c.items+'문항')) : (_pli?(String(c.items).replace(/\ud134$/,' turns')):c.items));
    return '<button type="button" class="pia-titem'+(dn?' done':'')+'"'
      + ' data-act=\'[["piaCloseCategory"],["piaGoTest","'+c.id+'"]]\''
      + ' aria-label="'+String(c.title).replace(/"/g,'')+(dn?(_pli?' (Done)':' (완료)'):'')+'">'
      + '<span class="pia-titem__ic" aria-hidden="true">'+(dn?'\u2713':(c.icon||'\uD83D\uDCDD'))+'</span>'
      + '<span class="pia-titem__tx">'
      +   '<span class="pia-titem__t">'+String(c.title).replace(/\s*\([^)]*\)\s*$/,'')+'</span>'
      +   (c.desc?'<span class="pia-titem__d">'+c.desc+'</span>':'')
      +   (meta.length?'<span class="pia-titem__m">'+meta.join(' \u00B7 ')+'</span>':'')
      + '</span>'
      + '<span class="pia-titem__st '+(dn?'d':'n')+'">'+(dn?(_pli?'Done':'완료'):(_pli?'Start':'시작'))+'</span>'
      + '</button>';
  }

  function openModal(title, lead, rowsHTML, titleId){
    piaCloseCategory();
    _lastFocus=document.activeElement;
    var _plmClose=(window.aipiaCurrentLang==='en')?'Close':'닫기';
    var m=document.createElement('div');
    m.className='pia-modal'; m.id='pia-modal';
    m.innerHTML='<div class="pia-modal__box" role="dialog" aria-modal="true" aria-labelledby="'+titleId+'">'
      +'<div class="pia-modal__hd">'
      +  '<h2 class="pia-modal__t" id="'+titleId+'">'+title+'</h2>'
      +  (lead?'<p class="pia-modal__lead">'+lead+'</p>':'')
      +'</div>'
      +'<div class="pia-modal__bd"><div class="pia-tlist">'+rowsHTML+'</div></div>'
      +'<div class="pia-modal__ft">'
      +  (window.PIA&&PIA.btn ? PIA.btn(_plmClose,'piaCloseCategory()','secondary')
                              : '<button type="button" data-act="piaCloseCategory">'+_plmClose+'</button>')
      +'</div></div>';
    m.addEventListener('click',function(e){ if(e.target===m) piaCloseCategory(); });
    document.body.appendChild(m);
    document.documentElement.style.overflow='hidden';   /* body overflow는 전파되지 않아 무효 */
    /* 포커스 이동 + 트랩 */
    var f=m.querySelector('.pia-titem, button'); if(f) f.focus();
    m.addEventListener('keydown', function(e){
      if(e.key!=='Tab') return;
      var els=m.querySelectorAll('button:not([disabled])'); if(!els.length) return;
      var first=els[0], last=els[els.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
    return m;
  }

  window.piaOpenCategory=function(catId){
    try{
      var _plc=(window.aipiaCurrentLang==='en');
      var cats=window._piaCats||[], cards=window._piaCards||[], isDone=window._piaIsDone;
      var cat=null; for(var i=0;i<cats.length;i++){ if(cats[i].id===catId){ cat=cats[i]; break; } }
      if(!cat){ console.error('알 수 없는 카테고리:', catId); return; }
      var _catsEn=window._piaCatsEn||{};
      var catL=(_plc&&_catsEn[catId])?Object.assign({},cat,_catsEn[catId]):cat;
      var byId={}; for(var j=0;j<cards.length;j++) byId[cards[j].id]=cards[j];
      var rows='';
      for(var t=0;t<catL.tests.length;t++){ var c=byId[catL.tests[t]]; if(c) rows+=itemHTML(c,isDone); }
      if(!rows) rows='<p class="pia-bodyL pia-muted">'+(_plc?'No assessments available yet.':'준비 중인 검사입니다.')+'</p>';
      var ttl=(catL.ic?catL.ic:'')+(catL.t||catL.title||(_plc?'Select Assessment':'검사 선택'));
      openModal(ttl, catL.d||catL.desc||'', rows, 'pia-modal-cat');
    }catch(e){
      console.error('piaOpenCategory:',e);
      if(window.PIA&&PIA.toast) PIA.toast((window.aipiaCurrentLang==='en')?'There was a problem opening the assessment list.':'검사 목록을 여는 중 문제가 생겼습니다.',4000);
    }
  };

  window.piaShowAllTests=function(){
    try{
      var _pla=(window.aipiaCurrentLang==='en');
      var cards=window._piaCards||[], isDone=window._piaIsDone;
      var rows='';
      for(var i=0;i<cards.length;i++) rows+=itemHTML(cards[i],isDone);
      openModal(_pla?'All Assessments':'전체 검사 목록', _pla?'The integrated report unlocks once you finish the 3 required assessments.':'필수 3종을 마치면 통합 결과지가 열립니다.', rows, 'pia-modal-all');
    }catch(e){
      console.error('piaShowAllTests:',e);
      if(window.PIA&&PIA.toast) PIA.toast((window.aipiaCurrentLang==='en')?'There was a problem opening the assessment list.':'검사 목록을 여는 중 문제가 생겼습니다.',4000);
    }
  };

  /* '선택 검사 더 알아보기' 를 인라인 펼침에서 모달로 바꾼다.
     앞쪽 IIFE 에도 같은 이름이 있지만 이 정의가 뒤에 실행되어 이긴다.
     여기서 정의하는 이유는 openModal 이 이 IIFE 의 지역 함수이기 때문. */
  window.piaToggleOptional=function(){
    try{
      var _plo=(window.aipiaCurrentLang==='en');
      var cats=window._piaCats||[], cards=window._piaCards||[], isDone=window._piaIsDone;
      var byId={}; for(var j=0;j<cards.length;j++) byId[cards[j].id]=cards[j];
      var rows='';
      for(var i=0;i<cats.length;i++){
        var _catsEn2=window._piaCatsEn||{};
        var k0=cats[i], k=(_plo&&_catsEn2[k0.id])?Object.assign({},k0,_catsEn2[k0.id]):k0, 전체=(k.tests||[]).length, 완료=0;
        for(var t=0;t<전체;t++){
          var c=byId[k.tests[t]];
          if(c){ try{ if(isDone(c)) 완료++; }catch(e){} }
        }
        var 메타=_plo?(전체+' assessments'+(완료?(' \u00B7 '+완료+' done'):'')):('검사 '+전체+'개'+(완료?(' \u00B7 '+완료+'개 완료'):''));
        rows+='<button type="button" class="pia-titem'+(전체&&완료===전체?' done':'')+'"'
          + ' data-act="piaOpenCategory" data-arg="'+k.id+'"'
          + ' aria-label="'+String(k.t||'').replace(/"/g,'')+'">'
          + '<span class="pia-titem__ic" aria-hidden="true">'+(k.ic||'')+'</span>'
          + '<span class="pia-titem__tx">'
          +   '<span class="pia-titem__t">'+(k.t||'')+'</span>'
          +   ((k.d||k.desc)?'<span class="pia-titem__d">'+(k.d||k.desc)+'</span>':'')
          +   '<span class="pia-titem__m">'+메타+'</span>'
          + '</span>'
          + '<span class="pia-titem__st n">'+(_plo?'View':'보기')+'</span>'
          + '</button>';
      }
      if(!rows) rows='<p class="pia-bodyL pia-muted">'+(_plo?'Nothing ready yet.':'준비 중입니다.')+'</p>';
      openModal(_plo?'Optional Assessments':'선택 검사', _plo?'Pick an area you\'re interested in. You can also do this after finishing the required assessments.':'관심 있는 영역을 골라보세요. 필수 검사를 마친 뒤에 해도 됩니다.', rows, 'pia-modal-opt');
    }catch(e){
      console.error('선택 검사 목록 열기 실패:', e);
      if(window.PIA&&PIA.toast) PIA.toast((window.aipiaCurrentLang==='en')?'There was a problem opening the optional assessment list.':'선택 검사 목록을 여는 중 문제가 생겼습니다.',4000);
    }
  };

  window.piaCloseCategory=function(){
    var m=document.getElementById('pia-modal')||document.getElementById('piav2-modal');
    if(m&&m.parentNode) m.parentNode.removeChild(m);
    document.documentElement.style.overflow='';
    try{ if(_lastFocus&&_lastFocus.focus) _lastFocus.focus(); }catch(e){}
    _lastFocus=null;
  };
})();
document.addEventListener('keydown',function(e){ if(e.key==='Escape') piaCloseCategory(); });


